import { render, staticRenderFns } from "./LocaleLanguage.vue?vue&type=template&id=babfabdc&scoped=true&"
import script from "./LocaleLanguage.vue?vue&type=script&lang=js&"
export * from "./LocaleLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babfabdc",
  null
  
)

export default component.exports